import React from "react";
import { useNavigate } from "react-router-dom";

//CSS
import "./crashCover.css";

//Components
import Button from "./button";

//Hooks
import { useTranslation } from "react-i18next";

const CrashCover = ({ error }) => {
  var buttonText;
  var onCLick;
  var header;
  var text;

  const navigate = useNavigate();

  const { t } = useTranslation();

  if (error?.errCode === 401) {
    header = t("Invalid account");
    text = t("Please login to access this page");
    buttonText = t("Login");
    onCLick = () => navigate("/login");
  } else if (error?.errCode === 403) {
    header = t("Access Denied");
    text = t("You do not have the permission to view this page");
    buttonText = t("Go Back");
    onCLick = () => navigate(-1);
  } else {
    header = t("Something went wrong");
    text = t("Please try again later");
    buttonText = t("Retry");
    onCLick = () => window.location.reload();
  }
  return (
    <div className="crash-cover" style={{ opacity: 1 }}>
      <h1 className="crash-cover-header">{header}</h1>
      <p className="crash-cover-text">{text}</p>
      <Button
        btnStyle={"btn-primary"}
        onClick={onCLick ? onCLick : () => window.location.reload()}
      >
        {buttonText}
      </Button>
    </div>
  );
};

export default CrashCover;
